export const productClasses = [
  "Ambient",
  "Beverages",
  "Bread & Bakery",
  "Dairy",
  "Fruits & Vegetables",
  "Kosher Meal",
  "Proteins",
  "Ready to Eat",
  "Packaging",
  "Frozen",
  "Chilled",
];
